// Core imports
import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component Imports
import { Card, Col, Row } from 'antd';
import AutomatedAnswersUsageSection from './AutomatedAnswersUsageSection';

// Misc imports
import { ANALYTICS_SECTIONS } from '../../constants/main';
import { useFetchAutomatedAnswersAnalyticsQuery } from '../../store/analytics/analyticsApi';
import { isEmptyArray } from '../../utils/is/isEmptyArray';

const AnalyticsAutomatedAnswersTab = ({
  requestParams,
  setIsLoading = () => false
}) => {

  const { data: automatedAnswersAnalytics, isFetching: isFetchingAutomatedAnswersAnalytics, isUninitialized } = useFetchAutomatedAnswersAnalyticsQuery({ ...requestParams?.[0] }, { skip: isEmptyArray(requestParams) });

  // Memoize loading state to prevent unnecessary re-renders
  const isLoading = useMemo(() =>
    isFetchingAutomatedAnswersAnalytics || isUninitialized,
  [isFetchingAutomatedAnswersAnalytics, isUninitialized]
  );

  useEffect(() => {
    setIsLoading(isLoading);

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  const renderAutomatedAnswersSection = () => {
    return (
      <Row gutter={[16, 16]} className="mb-5 hide-empty" id={`analytics-section_${ANALYTICS_SECTIONS.AUTOMATED_ANSWERS.key}`}>
        <Col xs={24} md={12} xxl={12} id={`analytics-section_${ANALYTICS_SECTIONS.AUTOMATED_ANSWERS.key}_${ANALYTICS_SECTIONS.AUTOMATED_ANSWERS.subSections.USAGE.key}`}>
          <Card className="h-100">
            <AutomatedAnswersUsageSection
              data={automatedAnswersAnalytics?.usage}
              sectionTitle={t('Usage')}
              isLoading={isLoading}
            />
          </Card>
        </Col>
      </Row>
    );
  };
  return (
    <Fragment>
      {renderAutomatedAnswersSection()}
    </Fragment>
  );
};

AnalyticsAutomatedAnswersTab.propTypes = {
  requestParams: PropTypes.array,
  setIsLoading: PropTypes.func
};

export default AnalyticsAutomatedAnswersTab;
